const initialvalues = {
    initialData: {},
    panchayithiwiseData: [],
    panchayithDrillDownData: [],
    popupdata: {},
    popupdata1: [],
    popupdata2: [],
    tradedata: {},
    CelltowerDetails: {},
    TapFeeDetails: {},
    auctiondashboard: [],
    tradescrollStatus: "top",
    auctionscrollStatus: "top",
    popDatasecVill: {},
    tabsecVillData: {},
    adhaarVerifiedData: {},
    adhaarSubmittedFormikData: {},
    verifyStatusadhaar: "",
    adhaarFeildArrayVerifiedData: {},
    adhaarFeildArrayFormikData: {},
    adhaarFeildArrayRowIndex: "",
    aadhaarFieldActiveStep: {},
    aadhaarValidStatus: null,
    aadhaarFieldRowModalPopup: {},
    aadhaarScodeField: null,
    assesmentConfirmRowData: {},
    confirmAssessmentFlag: "02",
    confirmSectraitVillage: {},
    psVerifyTradetarget: [],
    psVerifyCelltarget: []
}


export default function DrillDownReducer(details = initialvalues, action) {


    switch (action.type) {
        case "INITIALDATA":
            return { ...details, initialData: action.payload };

        case "PanchayithiWiseData":
            return { ...details, panchayithiwiseData: action.payload };

        case "PanchayithDrillDownData":
            return { ...details, panchayithDrillDownData: action.payload };

        case "POPUPDATA":
            return { ...details, popupdata: action.payload };

        case "POPUPDATA1":
            return { ...details, popupdata1: action.payload };
        case "POPUPDATA2":
            return { ...details, popupdata2: action.payload };

        case "TRADEDATA":
            return { ...details, tradedata: action.payload };
        case "Celltowerdetails":

            return { ...details, CelltowerDetails: action.payload };

        case "TapFeeDetails":

            return { ...details, TapFeeDetails: action.payload };
        case "AUCTIONDASHBOARD":
            return { ...details, auctiondashboard: action.payload };

        case "TRADE_SCROLL_STATUS":
            return { ...details, tradescrollStatus: action.payload };
        case "AUCTION_SCROLL_STATUS":
            return { ...details, auctionscrollStatus: action.payload };
        case "POPUPDATASECVILL":
            return { ...details, popDatasecVill: action.payload };
        case "TABSECVILLDATA":
            return { ...details, tabsecVillData: action.payload };
        case "AADHAARVERIFIEDDATA":
            return { ...details, adhaarVerifiedData: action.payload };
        case "AADHAARFORMIKSUBMITDATA":
            return { ...details, adhaarSubmittedFormikData: action.payload };
        case "VERIFYSTATUSADHAAR":
            return { ...details, verifyStatusadhaar: action.payload };
        case "ADHAARFIELDARRAYFORMIKDATA":
            return { ...details, adhaarFeildArrayFormikData: action.payload };
        case "ADHAARFIELDARRAYVERIFIEDATA":
            return { ...details, adhaarFeildArrayVerifiedData: action.payload };
        case "ADHAARFEILDARRAYROWINDEX":
            return { ...details, adhaarFeildArrayRowIndex: action.payload };
        case "ADHAARFEILDACTIVESTEP":
            return { ...details, aadhaarFieldActiveStep: action.payload };
        case "ADHAARVALIDSTATUS":
            return { ...details, aadhaarValidStatus: action.payload };
        case "ADHAARFIELDROWMODALPOPUP":
            return { ...details, aadhaarFieldRowModalPopup: action.payload };
        case "ADHAARSCODEFIELD":
            return { ...details, aadhaarScodeField: action.payload };
        case "ASSESSMENTCONFIRMROWDATA":
            return { ...details, assesmentConfirmRowData: action.payload };
        case "CONFIRMASSESSMENTFLAG":
            return { ...details, confirmAssessmentFlag: action.payload };
        case "CONFIRMSECTRAITVILLAGE":
            return { ...details, confirmSectraitVillage: action.payload };
        case "PSVERIFYTRADETARGET":
            return { ...details, psVerifyTradetarget: action.payload };
        case "PSVERIFYCELLTARGET":
            return { ...details, psVerifyCelltarget: action.payload };
        default:
            return details;
    }
}

